"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const vue_3 = require("vue");
exports.default = (0, vue_1.defineComponent)({
    __name: 'index',
    emits: ['node-click'],
    setup(__props, { emit: __emit }) {
        const label = (0, vue_3.ref)("");
        const backgroundUrl = (0, vue_3.ref)("");
        const usable = (0, vue_3.ref)();
        const getNode = (0, vue_3.inject)('getNode');
        const emit = __emit;
        const showNodeInfo = () => {
            emit('node-click', '');
        };
        (0, vue_3.onMounted)(() => {
            const node = getNode();
            const data = node.getData();
            label.value = data.label;
            backgroundUrl.value = data.imgUrl;
            usable.value = data.usable;
        });
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                class: (0, vue_2.normalizeClass)({ node: true, nodeBreathe: usable.value }),
                style: (0, vue_2.normalizeStyle)({ backgroundImage: `url(${backgroundUrl.value})` }),
                onClick: showNodeInfo
            }, (0, vue_2.toDisplayString)(label.value), 7));
        };
    }
});
